<template>

    <header class="app-header">
        <loader ref="loader"></loader>            
        <nav class="nav nav--primary">
            <ul class="list list--primary list--app">
                <li class="list-item" v-bind:class="{'is-active': isPageProjects}">
                    <a class="c-hover hover-wave" @click.prevent="loadPageProjects" :href="this.$router.resolve({path: projectsPath}).href">
                        <span class="c-hover" v-for="(letter, index) in ($translate.locale.projects.split(''))" v-bind:class="{'l-inline': letter === ' '}" v-bind:key="index">{{ letter }}</span>
                    </a>
                </li>
                <li class="list-item" v-bind:class="{'is-active': isPageAbout}">
                    <a class="c-hover hover-wave" @click.prevent="loadPageAbout" :href="this.$router.resolve({path: aboutPath}).href">
                        <span class="c-hover" v-for="(letter, index) in ($translate.locale.about.split(''))" v-bind:class="{'l-inline': letter === ' '}" v-bind:key="index">{{ letter }}</span>
                    </a>
                </li>
            </ul>

            <a :href="mailUrl" class="app-contact c-hover" ref="contactZone" v-on:mouseenter="initContactAnimation">
                <span class="contact-dialog c-hover" v-bind:class="{'is-visible': showDialog}">
                    <span class="dialog-text c-hover">{{copyText}}</span>
                </span>
                <span class="contact-content c-hover">
                    <span class="contact-text c-hover" ref="contactText">
                        <span class="c-hover">C</span>
                        <span class="c-hover">o</span>
                        <span class="c-hover">n</span>
                        <span class="c-hover">t</span>
                        <span class="c-hover">a</span>
                        <span class="c-hover">c</span>
                        <span class="c-hover">t</span>
                    </span>
                    <span class="contact-mail c-hover" ref="mail">
                        <span class="c-hover" v-for="(letter, index) in (mailName.split(''))" v-bind:class="{'l-inline': letter === ' '}" v-bind:key="index">{{ letter }}</span>
                        <span class="icon icon--copy c-hover" v-on:mouseenter="showDialog = true" v-on:mouseleave="showDialog = false; copyText = $translate.locale.copy" v-on:click="copyLink"></span>
                    </span>
                </span>
            </a>

            <ul class="list list--primary list--language">
                <li class="list-item" v-bind:class="{'is-disabled': isEng}">
                    <a class="c-hover hover-wave" :href="this.$router.resolve({path: engRoutePath, params: {projectId: routeParams}}).href" @click.prevent="switchToEn"><span class="c-hover">E</span><span class="c-hover">n</span></a>
                </li>
                <li class="list-item" v-bind:class="{'is-disabled': !isEng}">
                    <a class="c-hover hover-wave" :href="this.$router.resolve({path: frRoutePath}).href" @click.prevent="switchToFr"><span class="c-hover">F</span><span class="c-hover">r</span></a>
                </li>
            </ul>
        </nav>
    </header>

</template>

<script>
    
    import Loader from '../Loader/Loader.vue'

    export default {
        
        components: {
            Loader
        },
        
        data() {
            return {
                isEng: true,
                engRoutePath: '',
                frRoutePath: '',
                aboutPath: '',
                projectsPath: '',
                projectPath: '',
                routeParams: false,
                isPageAbout: false,
                isPageProjects: false,
                isMailHovered: false,
                hoverActive: false,
                showDialog: false,
                mailName: '',
                mailUrl: '',
                copyText: '',
                hoverTimeout : false,
                html: document.documentElement,
                metaInfos: {
                    general: {
                        title: {
                            en: 'Julien Barreira - Front-End Developer',
                            fr: 'Julien Barreira - Développeur Front-End'
                        },
                        description: {
                            en: 'Portfolio of Julien Barreira. Martinique based Front-End Developer. Currently available for Freelance missions.',
                            fr: 'Portfolio de Julien Barreira. Développeur Front-End basé en Martinique. Actuellement disponible pour des missions Freelance.'
                        },
                        alternate: {
                            home: {
                                en: 'https://julienbarreira.com',
                                fr: 'https://julienbarreira.com/fr'
                            },
                            
                        },
                        routes: {
                            projects_component: {
                                en: 'https://julienbarreira.com',
                                fr: 'https://julienbarreira.com/fr'
                            },
                            about_component: {
                                en: 'https://julienbarreira.com/about',
                                fr: 'https://julienbarreira.com/a-propos'
                            },
                            project_component: {
                                en: 'https://julienbarreira.com/project/',
                                fr: 'https://julienbarreira.com/projet/'
                            }
                        }
                    },
                    
                }
            }
        },
        
        metaInfo () {
            return {
                meta: [
                    {vmid: 'description', name: 'description', content: this.metaInfos.general.description[this.$translate.lang]},
                    
                    {property: 'og:title', content: this.metaInfos.general.title[this.$translate.lang]},
                    {property: 'og:type', content: 'website'},
                    {property: 'og:url', content: 'https://julienbarreira.com'},
                    {property: 'og:image', content: 'https://julienbarreira.com/static/images/screenshot.jpg'},
                    {property: 'og:description', content: this.metaInfos.general.description[this.$translate.lang]},
                    
                    {name: 'twitter:site', content: 'https://julienbarreira.com'},
                    {name: 'twitter:title', content: this.metaInfos.general.title[this.$translate.lang]},
                    {name: 'twitter:description', content: this.metaInfos.general.description[this.$translate.lang]},
                    {name: 'twitter:image:src', content: 'https://julienbarreira.com/static/images/screenshot.jpg'},
                ],
                link: [                    
                    {rel: 'canonical', href: 'https://julienbarreira.com' + this.$route.path},
                    {rel: 'alternate', hreflang:'en', href: this.metaInfos.general.routes[this.$route.name].en + (typeof(this.$route.params.projectId) !== 'undefined' ? this.$route.params.projectId : '' )},
                    {rel: 'alternate', hreflang:'fr', href: this.metaInfos.general.routes[this.$route.name].fr + (typeof(this.$route.params.projectId) !== 'undefined' ? this.$route.params.projectId : '' )}
                ],
                script: [
                  { innerHTML: '{' +
                    '"@context": "http://schema.org",' +
                    '"@type": "person",' +
                    '"name": "Julien Barreira",' +
                    '"jobTitle": "'+ this.metaInfos.general.title[this.$translate.lang] +'",' +
                    '"url": "https://julienbarreira.com",' +
                    '"sameAs" : [' +
                        '"https://www.linkedin.com/in/julien-barreira-128605108/",' +
                        '"https://codepen.io/JulienBarreira/"' +
                    '],' +
                    '"email": "julien.barreira.dev@gmail.com",' +
                    '"birthDate": "1992-07-11"' +
                    '"image": "https://julienbarreira.com/statics/images/portrait.jpg",' +
                    '}'
                    , type: 'application/ld+json' }
                ]
            }
        },
        
        locales: {
            en: {
                'projects': 'Projects',
                'about': 'About',
                'copy': 'Copy',
                'copied': 'Copied'
            },
            fr: {
                'projects': 'Projets',
                'about': 'A propos',
                'copy': 'Copier',
                'copied': 'Copié'
            }
        },
        
        beforeMount() {            
            if (this.$route.name === "projects_component") {   
                
                var navigatorLang = ''
                
                if (typeof(navigator.language) !== 'undefined') {
                    navigatorLang = navigator.language
                } else if (typeof(navigator.userLanguage) !== 'undefined') {
                    navigatorLang = navigator.userLanguage
                }
                
                if (navigatorLang.includes('fr')) {
                    this.$translate.setLang('fr')
                    this.isEng = false
                    this.html.setAttribute('lang', 'fr')
                    
                    if (this.$route.path !== '/fr') {
                        this.$router.replace({path: '/fr'})
                    }
                } else {
                    this.$translate.setLang('en')
                    this.isEng = true
                    this.html.setAttribute('lang', 'en')
                }
                
            } else {
                if (this.$route.path.includes('/fr/')) {
                    this.$translate.setLang('fr')
                    this.isEng = false
                    this.html.setAttribute('lang', 'fr')
                } else {
                    this.$translate.setLang('en')
                    this.isEng = true
                    this.html.setAttribute('lang', 'en')
                }
            }
        },
        
        mounted() {            
            this.setLinksPath()
            
            this.copyText = this.$translate.locale.copy
            
            this.setEmailUrl()
        },
        
        updated() {
            this.setRouteTraductionNames()
        },
                
        methods: {
                        
            setLinksPath() {
                if (this.$translate.lang === 'fr') {                        
                    this.aboutPath = '/fr/a-propos'
                    this.projectsPath = '/fr'
                    this.projectPath = '/fr/projet'
                } else {                        
                    this.aboutPath = '/about'
                    this.projectsPath = '/'
                    this.projectPath = '/project'
                }
                
                this.copyText = this.$translate.locale.copy
            },
            
            setRouteTraductionNames() {
                if (this.$route.name === "projects_component") {
                    
                    this.engRoutePath = '/'
                    this.frRoutePath = '/fr'
                    
                    this.isPageAbout = false
                    this.isPageProjects = true
                    
                } else if (this.$route.name === "project_component") {
                    
                    this.engRoutePath = '/project' + '/' + this.$route.params.projectId
                    this.frRoutePath = '/fr/projet' + '/' + this.$route.params.projectId
                                        
                    this.isPageAbout = false
                    this.isPageProjects = true
                    
                } else if (this.$route.name === "about_component") {   
                    
                    this.engRoutePath = '/about'
                    this.frRoutePath = '/fr/a-propos'
                    
                    this.isPageAbout = true
                    this.isPageProjects = false
                    
                }
            },
            
            loadPageProjects() {
                if (!this.$refs.loader.isLoading) {
                    this.$router.push({path: this.projectsPath})
                }
            },
            
            loadPageAbout() {
                if (!this.$refs.loader.isLoading) {
                    this.$router.push({path: this.aboutPath})
                }
            },
                        
            switchToEn() {
                // cette condition permet d'éviter le bug quand le slider est en pleine animation et qu'on change de langue
                var block = false
                if (typeof(this.$parent.$refs.routerRef.initCanvasSlideshow) !== 'undefined') {
                    if (this.$parent.$refs.routerRef.initCanvasSlideshow) {
                        block = this.$parent.$refs.routerRef.initCanvasSlideshow.checkIfPlaying()
                    }
                }
                
                if (this.$translate.lang !== "en" && !this.$refs.loader.isLoading && !block) {

                    var self = this
                    this.$refs.loader.isLoading = true
                    
                    if (this.$route.name === "projects_component") {
                        
                        this.$refs.loader.LoadAnimationAdd()
                        
                        setTimeout(function () {
                            self.$router.replace({path: '/'})
                            setTimeout(function () {
                                self.setSlidesOpacity()
                            }, 10)
                            self.$refs.loader.LoadAnimationRemove()
                        }, 800)
                    }
                    else if (this.$route.name === "about_component") {
                        
                        this.$refs.loader.LoadAnimationAdd()
                        
                        setTimeout(function () {
                            self.$router.replace({path: '/about'})
                            self.$refs.loader.LoadAnimationRemove()
                        }, 800)
                    }
                    else if (this.$route.name === "project_component") {
                        this.$refs.loader.LoadAnimationAdd()
                        
                        setTimeout(function () {
                            self.$router.replace({path: '/project' + '/' + self.$route.params.projectId})
                            setTimeout(function () {
                                self.setSlidesOpacity()
                            }, 10)
                            self.$refs.loader.LoadAnimationRemove()
                        }, 800)                        
                    }
                    
                    setTimeout(function () {
                        self.$translate.setLang('en')
                        self.isEng = true
                        self.html.setAttribute('lang', 'en')
                        self.setLinksPath()
                        self.$refs.loader.isLoading = false
                    }, 800)
                    
                }
            },
            
            switchToFr() {
                // cette condition permet d'éviter le bug quand le slider est en pleine animation et qu'on change de langue
                var block = false
                if (typeof(this.$parent.$refs.routerRef.initCanvasSlideshow) !== 'undefined') {
                    if (this.$parent.$refs.routerRef.initCanvasSlideshow) {
                        block = this.$parent.$refs.routerRef.initCanvasSlideshow.checkIfPlaying()
                    }
                }
                
                if (this.$translate.lang !== "fr" && !this.$refs.loader.isLoading && !block) {

                    var self = this
                    this.$refs.loader.isLoading = true
                    
                    if (this.$route.name === "projects_component") {

                        this.$refs.loader.LoadAnimationAdd()
                        
                        setTimeout(function () {
                            self.$router.replace({path: '/fr'})
                            setTimeout(function () {
                                self.setSlidesOpacity()
                            }, 10)
                            self.$refs.loader.LoadAnimationRemove()
                        }, 800)
                    }
                    else if (this.$route.name === "about_component") {
                        
                        this.$refs.loader.LoadAnimationAdd()
                        
                        setTimeout(function () {
                            self.$router.replace({path: '/fr/a-propos'})
                            self.$refs.loader.LoadAnimationRemove()
                        }, 800)
                    }
                     else if (this.$route.name === "project_component") {
                        this.$refs.loader.LoadAnimationAdd()
                        
                        setTimeout(function () {
                            self.$router.replace({path: '/fr/projet' + '/' + self.$route.params.projectId})
                            setTimeout(function () {
                                self.setSlidesOpacity()
                            }, 10)
                            self.$refs.loader.LoadAnimationRemove()
                        }, 800)                        
                    }
                    
                    setTimeout(function () {
                        self.$translate.setLang('fr')
                        self.isEng = false
                        self.html.setAttribute('lang', 'fr')
                        self.setLinksPath()
                        self.$refs.loader.isLoading = false
                    }, 800)

                }
            },
            
            initContactAnimation() {                
                if (!this.$parent.isMobile) {                    
                    this.hoverActive = true

                    if (!this.isMailHovered) {                    
                        var self = this
                        this.isMailHovered = true

                        var baseTimeline = new TimelineMax({
                            onComplete: function() {
                                self.mouseInContactAnimation(self)
                            }
                        });
                        baseTimeline.staggerTo(this.$refs.contactText.querySelectorAll("span"), 0.2, {
                            x: 5,
                            y: 5,
                            autoAlpha: 0
                        }, 0.03)
                    }
                    if (this.hoverTimeout !== false) {
                        clearTimeout(this.hoverTimeout)
                    }

                    this.addHoverEvent()
                }
            },
            
            mouseInContactAnimation(self) {
                self.$refs.contactZone.classList.add('is-hovered')
                var mailLetters = self.$refs.mail.querySelectorAll("span")

                TweenMax.staggerTo(mailLetters, 0, {
                    x: -5,
                    y: -5,
                    autoAlpha: 0
                }, 0.02)
                TweenMax.staggerTo(mailLetters, 0.2, {
                    x: 0,
                    y: 0,
                    autoAlpha: 1
                }, 0.02)
            },
            
            addHoverEvent() {
                this.$refs.contactZone.addEventListener('mouseleave', this.unHover)
            },
            
            removeHoverEvent() {
                this.$refs.contactZone.removeEventListener('mouseleave', this.unHover)
            },
            
            unHover() {
                this.hoverActive = false
                this.removeHoverEvent()
                var self = this
                
                this.hoverTimeout = setTimeout(function() {
                    if (!self.hoverActive) {
                        
                        var mailLetters = self.$refs.mail.querySelectorAll("span")
                        
                        var baseTimeline = new TimelineMax({
                            onComplete: function() {
                                self.$refs.contactZone.classList.remove('is-hovered')                                
                                self.isMailHovered = false
                                var contactLetters = self.$refs.contactText.querySelectorAll("span")
                                
                                TweenMax.staggerTo(contactLetters, 0, {
                                    x: -5,
                                    y: -5,
                                    autoAlpha: 0
                                }, 0.02)
                                TweenMax.staggerTo(contactLetters, 0.2, {
                                    x: 0,
                                    y: 0,
                                    autoAlpha: 1
                                }, 0.02)
                            }
                        });
                        baseTimeline.staggerTo(mailLetters, 0.2, {
                            x: 5,
                            y: 5,
                            autoAlpha: 0
                        }, 0.03)                        
                    }
                }, 2000)
            },
            
            setEmailUrl() {
                if (this.mailName === '') {                                        
                    var name = 'neiluj',
                        surname = 'arierrab',
                        job = 'ved',
                        client = 'liamg'

                    var mailName = 'moc.' + client + '@' + job + '.' + surname + '.' + name
                    this.mailName = mailName.split("").reverse().join("");
                    this.mailUrl = 'mailto:' + this.mailName
                }
            },
            
            copyLink(event) {
                event.preventDefault();
                
                var el = document.createElement('textarea');
                el.value = this.mailName;
                el.setAttribute('readonly', '');
                el.style.position = 'absolute';
                el.style.left = '-9999px';
                document.body.appendChild(el);
                var selected =
                    document.getSelection().rangeCount > 0
                    ? document.getSelection().getRangeAt(0)
                    : false;
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
                if (selected) {
                    document.getSelection().removeAllRanges();
                    document.getSelection().addRange(selected);
                }
                
                this.copyText =  this.$translate.locale.copied
            },
            
            setSlidesOpacity() {
                // sans cette fonction et le timing associés les titres sont coupés au changement de langue
                if (!this.$parent.isMobile) {
                    
                    if (this.$parent.$refs.routerRef.isList) {
                        var allSlideLetters = document.getElementById('slider-projects').querySelectorAll(".item-title span span")
                        TweenMax.set(allSlideLetters, {autoAlpha: 1})
                    } else {
                        var projectsArray = document.getElementById('slider-projects').getElementsByClassName('list-item')
                        var currentSlide = projectsArray[this.$parent.$refs.routerRef.initCanvasSlideshow.currentIndex]
                        var currentSlideLetters = currentSlide.querySelectorAll(".item-title span span")
                        TweenMax.set(currentSlideLetters, {autoAlpha: 1})
                    }
                }
            }
            
        }
        
    }
    
</script>


// WEBPACK FOOTER //
// src/components/AppBase/AppBase.vue